// components/chat/queryExplorerMessage/QueryExplorerMessage.tsx
import React, { useState } from 'react';

import QueryExplorer from 'components/explorer/QueryExplorer';
import './QueryExplorerMessage.scss';

const QueryExplorerMessage = (): React.ReactElement => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className='query-explorer-message'>
      <button className='query-explorer-header' onClick={toggleCollapse}>
        <span>{isCollapsed ? '▶' : '▼'} Query Explorer</span>
      </button>
      {!isCollapsed && (
        <div className='query-explorer-content'>
          <QueryExplorer />
        </div>
      )}
    </div>
  );
};

export default QueryExplorerMessage;
